/**
 * Which install help a visitor's browser needs, from what it says about
 * itself. Pure, so it can be tested against real browser descriptions.
 */
export type DetectedDevice = {
  ios: boolean;
  android: boolean;
  /** Android browser built into another app (Google Lens, Facebook…): cannot install. */
  inAppBrowser: boolean;
};

export function detectDevice(input: {
  userAgent: string;
  maxTouchPoints: number;
  /** `"standalone" in navigator`: only Apple's WebKit has it. */
  hasStandalone: boolean;
  /** navigator.userAgentData.platform, where the browser offers it. */
  platform?: string;
}): DetectedDevice {
  const ua = input.userAgent;
  const android = /Android/.test(ua) || input.platform === "Android";
  // iPadOS reports itself as a Mac with a touch screen — but so do some
  // Android browsers in "desktop site" mode, which then got the iPhone's
  // Safari steps (owner, 2 Oct 2026). Only Apple's WebKit has
  // navigator.standalone, so that settles it.
  const ios =
    !android &&
    (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && input.maxTouchPoints > 1 && input.hasStandalone));
  const inAppBrowser = android && /; wv\)|GSA\/|FBAN|FBAV|Instagram|Line\//.test(ua);
  return { ios, android, inAppBrowser };
}
